import { Injectable } from '@angular/core';
import {HttpService} from './../http.service';
import {environment} from '@shared-environments/environment';
import {appConstants} from "@cybfed/constants";

@Injectable()
export class DonationNotificationService {

  constructor(private networkHelper: HttpService) { }


  private createUrlUrl = '/donationNotification';
  private getListUrl = '/donationNotification/list';
  private searchUrl = '/donationNotification/search';
  private updateUrl = '/donationNotification/:id';
  private getUrl = '/donationNotification/:id';
  private deleteUrl = '/donationNotification/:id';

  create(createData: any){
    return this.networkHelper.post<any>(environment.apiURL + this.createUrlUrl, createData);
  }

  getList(filter: any): any {
    return this.networkHelper.get<any>(environment.apiURL + this.getListUrl, filter);
  }

  search(filter: any): any {
    return this.networkHelper.get<any>(environment.apiURL + this.searchUrl, filter);
  }

  update(id: string, data: any){
    return this.networkHelper.put<any>(environment.apiURL + this.updateUrl.replace(':id', id), data);
  }

  get(id: string){
    return this.networkHelper.get<any>(environment.apiURL + this.getUrl.replace(':id', id));
  }


  delete(id:string):any {
    return this.networkHelper.del<any>(environment.apiURL + this.deleteUrl.replace(':id', id));
  }


}
